import { render, staticRenderFns } from "./video.vue?vue&type=template&id=109686ff&scoped=true&"
import script from "./video.vue?vue&type=script&lang=js&"
export * from "./video.vue?vue&type=script&lang=js&"
import style0 from "./video.vue?vue&type=style&index=0&id=109686ff&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109686ff",
  null
  
)

export default component.exports